import { t } from '@lingui/core/macro';
import type { NoddiIconName } from 'noddi-ui-common';

export const addressLabels = [
  'home',
  'work',
  'cabin',
  'office',
  'parents',
  'parking',
  'invoice',
  'partner',
  'custom'
] as const;

export const getAddressLabel = (label: (typeof addressLabels)[number]): string => {
  switch (label) {
    case 'home':
      return t`Home`;
    case 'work':
      return t`Work`;
    case 'cabin':
      return t`Cabin`;
    case 'office':
      return t`Office`;
    case 'parents':
      return t`Parents`;
    case 'parking':
      return t`Parking`;
    case 'invoice':
      return t`Invoice`;
    case 'partner':
      return t`Partner`;
    case 'custom':
      return t`Custom`;
  }
};

export const addressLabelIcons: Record<(typeof addressLabels)[number], NoddiIconName> = {
  home: 'Home',
  work: 'BriefcaseBusiness',
  cabin: 'MountainSnow',
  office: 'Building2',
  parents: 'Heart',
  parking: 'Car',
  invoice: 'FileText',
  partner: 'Handshake',
  custom: 'HousePlus'
};
